import React, { useEffect, useState } from 'react';
import { LeftOutlined } from '@ant-design/icons';
import { Input, Steps, Button, Form, Radio, Space, message } from 'antd';
import "../styles/store.css";
import "../styles/preview.css";
import "../styles/checkout.css";
import { Select } from "antd";
import user from "../assets/user.png";
import mail from "../assets/mail.png";
import visa from "../assets/checkout/visa.png";
import credit from "../assets/checkout/credit.png";
import cash from "../assets/checkout/cash.png";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
// import { fetchUser } from "../redux/getUserSlice";
import {
    fetchUser,
    updateProfile,
} from "../redux/ecommerce/getUserSlice";
import {
    setOrderField,
    setOrderData,
    submitOrder,
    resetOrderData,
} from "../redux/ecommerce/submitOrderSlice";
import {
    fetchAllOrdersCart,
    setExpressDelivery,
    setCoupon,
    clearCoupon,
} from "../redux/ecommerce/cartSlice";
import { payOrder } from '../redux/ecommerce/paymentSlice';

const Checkout = () => {

    const { t, i18n } = useTranslation();
    const { language } = i18n;

    const [current, setCurrent] = useState(0);

    const next = () => {
        setCurrent(current + 1);
    };

    const prev = () => {
        setCurrent(current - 1);
    };

    const onFinish = (values) => {
        console.log('Form Data:', values);
    };

    const dispatch = useDispatch();

    const {
        ordersCart,
        status,
        expressDelivery,
        expressStatus,
        couponStatus,
        couponError,
        coupon,
    } = useSelector((state) => state.cart);

    const { getUser } = useSelector((state) => state.getUser);
    const { updateStatus } = useSelector(
        (state) => state.getUser
    );
    const { orderData, status: submitStatus, error: submitError } = useSelector(
        (state) => state.submitOrder
    );

    useEffect(() => {
        dispatch(fetchUser());
    }, [dispatch]);

    useEffect(() => {
        if (status === "idle") {
            dispatch(fetchAllOrdersCart());
        }
    }, [status, dispatch]);

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [address, setAddress] = useState("");
    const [phone, setPhone] = useState("");

    const handleContinue = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append("name", getUser.name || "");
        formData.append("last_name", getUser.last_name || "");
        formData.append("email", getUser.email || "");
        formData.append("phone", getUser.phone || "");
        formData.append("address", address);

        const result = await dispatch(updateProfile(formData));

        if (updateProfile.fulfilled.match(result)) {
            dispatch(fetchUser());
            next();
        } else {
            message.error(
                result.payload || "Failed to update address"
            );
        }
    };

    const orderId = ordersCart[0]?.id;

    useEffect(() => {
        if (getUser) {
            dispatch(setOrderData({
                first_name: getUser.name || '',
                last_name: getUser.last_name || '',
                phone: getUser.phone || '',
                email: getUser.email || '',
                address: getUser.address || '',
                order_id: orderId || null,
            }));
        }
    }, [getUser, orderId, dispatch]);

    const [couponInput, setCouponInput] = useState("");

    // const [value, setValue] = useState(1);
    // const onChangeShipping = (e) => {
    //     console.log("radio checked", e.target.value);
    //     setValue(e.target.value);
    // };

    useEffect(() => {
        if (getUser) {
            setFirstName(getUser.name || "");
            setLastName(getUser.last_name || "");
            setEmail(getUser.email || "");
            setAddress(getUser.address || "");
            setPhone(getUser.phone || "");
        }
    }, [getUser]);

    const [expressSelected, setExpressSelected] = useState(false);

    const onChangeShipping = (e) => {
        const checked = e.target.value === 2;
        setExpressSelected(checked);
        if (orderId) {
            dispatch(setExpressDelivery({
                order_id: orderId,
                status: checked ? "yes" : "no",
            })).then((result) => {
                if (result.meta.requestStatus === "fulfilled") {
                    message.success(checked ? "Express delivery enabled" : "Express delivery disabled");
                } else {
                    message.error("Failed to update delivery option");
                }
            });
        }
    };

    const [pay, setPay] = useState("credit");
    const onChangePay = (e) => {
        setPay(e.target.value);
        dispatch(setOrderField({ field: "payment_method", value: e.target.value }));
    };

    const handleVerifyCoupon = () => {
        if (!couponInput.trim()) {
            message.warning("Please enter a coupon code");
            return;
        }
        if (!orderId) {
            message.warning("No active order found");
            return;
        }
        dispatch(setCoupon({ order_id: orderId, coupon: couponInput.trim() }))
            .then((result) => {
                if (result.meta.requestStatus === "fulfilled") {
                    message.success("Coupon applied successfully");
                } else {
                    message.error("Invalid coupon code");
                }
            });
    };

    const handleClearCoupon = () => {
        dispatch(clearCoupon());
        setCouponInput("");
    };

    // const handleSubmitOrder = () => {
    //     const finalOrderData = {
    //         first_name: firstName,
    //         last_name: lastName,
    //         phone: phone,
    //         email: email,
    //         address: address,
    //         express_delivery: expressSelected,
    //         payment_method: pay,
    //         card_name: pay === "credit" ? cardName : "",
    //         card_number: pay === "credit" ? cardNumber.replace(/\s/g, "") : "",
    //         expiry_date: pay === "credit" ? expiryDate : "",
    //         cvv: pay === "credit" ? cvv : "",
    //         coupon: coupon,
    //         order_id: orderId,
    //     };

    //     dispatch(submitOrder(finalOrderData)).then((result) => {
    //         if (result.meta.requestStatus === "fulfilled") {
    //             message.success("Order submitted successfully!");
    //             dispatch(resetOrderData());
    //         } else {
    //             message.error("Failed to submit order");
    //         }
    //     });
    // };


    const handleSubmitOrder = async () => {
        const finalOrderData = {
            eco_order_id: orderId,
            type: pay === "credit" ? "visa" : "cash",
            device: "web",
        };

        try {
            // Step 1: Submit the order
            const orderResult = await dispatch(
                submitOrder(finalOrderData)
            );



            if (!submitOrder.fulfilled.match(orderResult)) {
                message.error("Failed to submit order");
                return;
            }

            const responseData = orderResult.payload;

            if (pay === "credit" && responseData?.payment_url) {
                window.location.href = responseData.payment_url;
                return;
            }

            message.success("Order submitted successfully!");

            dispatch(resetOrderData());
        } catch (error) {
            message.error("Something went wrong");
        }
    };

    return (
        <div className='px-20 max-lg:px-5 my-10 checkout'>
            <Link to="/cart" className='flex items-center text-[#283D63] font-semibold mb-5'>
                <LeftOutlined />
                <p className='ml-3'>Back to cart</p>
            </Link>
            <h2 className="text-[#14294F] text-3xl font-bold leading-relaxed mb-5">
                Checkout
            </h2>

            <div className='grid grid-cols-3 max-lg:grid-cols-1 gap-14 max-lg:gap-4'>
                <div className='lg:col-span-2'>
                    <Steps
                        current={current}
                        labelPlacement="vertical"
                        className='w-1/2 max-lg:w-full max-lg:flex-row'
                        items={[
                            { title: 'Shipment' },
                            { title: 'Payment' },
                        ]}
                    />

                    <div className="mt-8">
                        {current === 0 && (
                            <form>
                                <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-10 max-lg:gap-4">
                                    <div>
                                        <p className="text-[#283D63] font-semibold">
                                            First Name <span className="text-[#CC0F0F]">*</span>
                                        </p>
                                        <Input
                                            placeholder="Eg. Johnny"
                                            value={firstName}
                                            onChange={(e) => setFirstName(e.target.value)}
                                            suffix={<img src={user} className="w-[15px]" />}
                                            className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                                            readOnly
                                        />
                                    </div>
                                    <div>
                                        <p className="text-[#283D63] font-semibold">
                                            Last Name <span className="text-[#CC0F0F]">*</span>
                                        </p>
                                        <Input
                                            placeholder="Eg. Doe"
                                            value={lastName}
                                            onChange={(e) => setLastName(e.target.value)}
                                            suffix={<img src={user} className="w-[15px]" />}
                                            className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                                            readOnly
                                        />
                                    </div>
                                </div>

                                <div className='mt-5'>
                                    <p className="text-[#283D63] font-semibold">
                                        Phone Number <span className="text-[#CC0F0F]">*</span>
                                    </p>

                                    <div dir="ltr">
                                        <PhoneInput
                                            defaultCountry="sa"
                                            value={phone}
                                            onChange={(phone) => setPhone(phone)}
                                            className={`bg-white w-full mt-2 rounded placeholder:text-black placeholder:text-xl placeholder:font-normal placeholder:font-Arimo`}
                                            readOnly
                                        />
                                    </div>
                                </div>

                                <div className='mt-5'>
                                    <p className="text-[#283D63] font-semibold">
                                        Email <span className="text-[#CC0F0F]">*</span>
                                    </p>
                                    <Input
                                        placeholder="Eg. Solimannhene16@gmail.com"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        suffix={<img src={mail} className="w-[20px]" />}
                                        className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                                        readOnly
                                    />
                                </div>


                                {/* <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-10 max-lg:gap-4 mt-5">
                                    <div>
                                        <p className="text-[#283D63] font-semibold">
                                            Country <span className="text-[#CC0F0F]">*</span>
                                        </p>
                                        <Select
                                            defaultValue="one"
                                            className="w-full mt-2"
                                            onChange={handleChange}
                                            options={[
                                                {
                                                    value: "two",
                                                    label: "Choose one or more services",
                                                },
                                                {
                                                    value: "one",
                                                    label: "Choose country",
                                                },
                                            ]}
                                        />
                                    </div>
                                    <div>
                                        <p className="text-[#283D63] font-semibold">
                                            City <span className="text-[#CC0F0F]">*</span>
                                        </p>
                                        <Select
                                            defaultValue="one"
                                            className="w-full mt-2"
                                            onChange={handleChange}
                                            options={[
                                                {
                                                    value: "two",
                                                    label: "Choose one or more services",
                                                },
                                                {
                                                    value: "one",
                                                    label: "Choose city",
                                                },
                                            ]}
                                        />
                                    </div>
                                </div> */}

                                <div className="mt-5">
                                    <p className="text-[#283D63] font-semibold">
                                        Address <span className="text-[#CC0F0F]">*</span>
                                    </p>
                                    <Input
                                        placeholder="Write tour address in details eg. place / Street / Building name / Apartment"
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                        className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                                        required
                                    />
                                </div>

                                <Radio.Group
                                    onChange={onChangeShipping}
                                    value={expressSelected ? 2 : 1}
                                    className="mt-5 text-lg text-[#525A6B]"
                                >
                                    <Space direction="vertical">
                                        <Radio value={1}>Standard Delivery</Radio>
                                        <Radio value={2}>
                                            Express Delivery (65 SR)
                                            {expressStatus === "loading" && (
                                                <span className="text-[#A5AFC0] ml-2 text-sm">updating...</span>
                                            )}
                                        </Radio>
                                    </Space>
                                </Radio.Group>

                            </form>
                        )}

                        {current === 1 && (
                            <form>
                                <div className='bg-[#FCFBFA] py-5 lg:mr-10 rounded-2xl'>

                                    <div className='flex items-center justify-between bg-[#FCFBFA] rounded-2xl mx-7 max-lg:mx-3 py- lg:mr-10'>
                                        <Radio.Group
                                            onChange={onChangePay}
                                            value={pay}
                                            className=" text-lg text-[#525A6B]"
                                        >
                                            <Space direction="vertical">
                                                <Radio value="credit">Credit / Debit Card</Radio>
                                            </Space>
                                        </Radio.Group>
                                        <div>
                                            <img src={credit} className="w-[30px]" />
                                        </div>
                                    </div>

                                    {/* <div className="my-5 mx-7 max-lg:mx-3">
                                        <div className="bg-white border-2 border-[#EAA182] rounded-3xl p-7">

                                            <div>
                                                <p className="text-[#283D63] font-semibold">
                                                    Card Name <span className="text-[#CC0F0F]">*</span>
                                                </p>
                                                <Input
                                                    placeholder="Eg. Johnny Noe"
                                                    className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                                                />
                                            </div>

                                            <div className='mt-5'>
                                                <p className="text-[#283D63] font-semibold">
                                                    Card Number <span className="text-[#CC0F0F]">*</span>
                                                </p>
                                                <Input
                                                    placeholder="0000 0000 0000 0000"
                                                    value={cardNumber}
                                                    onChange={handleCardNumberChange}
                                                    suffix={<img src={visa} className="w-[70px]" />}
                                                    className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                                                />
                                            </div>

                                            <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-10 mt-5">
                                                <div>
                                                    <p className="text-[#283D63] font-semibold">
                                                        Expiry Date <span className="text-[#CC0F0F]">*</span>
                                                    </p>
                                                    <Input
                                                        placeholder="MM/YY"
                                                        value={expiryDate}
                                                        onChange={handleExpiryDateChange}
                                                        className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                                                    />
                                                </div>
                                                <div>
                                                    <p className="text-[#283D63] font-semibold">
                                                        Cvv <span className="text-[#CC0F0F]">*</span>
                                                    </p>
                                                    <Input
                                                        placeholder="123"
                                                        value={cvv}
                                                        onChange={handleCvvChange}
                                                        className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}


                                </div>

                                <div className='flex items-center justify-between bg-[#FCFBFA] rounded-2xl mt-7 max-lg:mx-3 px-5 py-4 lg:mr-10'>
                                    <Radio.Group
                                        onChange={onChangePay}
                                        value={pay}
                                        className="text-lg text-[#525A6B]"
                                    >
                                        <Space direction="vertical">
                                            <Radio value="cash">Cash on Delivery</Radio>
                                        </Space>
                                    </Radio.Group>
                                    <div>
                                        <img src={cash} className="w-[30px]" />
                                    </div>
                                </div>
                            </form>
                        )}
                    </div>
                </div>


                <div>
                    <div className="bg-[#FCFBFA] p-4 rounded-3xl">
                        {/* <div className="bg-white border-2 border-[#EAA182] rounded-3xl py-6 text-lg">
                            <h3 className="text-[#14294F] text-2xl text-center font-bold leading-relaxed mb-5">
                                Order Summary
                            </h3>
                            <div className="flex items-center justify-between px-5">
                                <p className="text-[#737E91]">x2 Cage Lamp</p>
                                <p className="text-[#283D63]">200 SR</p>
                            </div>
                            <div className="flex items-center justify-between mt-3 px-5">
                                <p className="text-[#737E91]">x1 Tornado Vase XXL</p>
                                <p className="text-[#283D63]">700 SR</p>
                            </div>

                            <hr className="border border-[#FBDED2] my-5" />

                            <p className="text-[#A5AFC0] text-base px-4">Shipping</p>
                            <div className="flex items-center justify-between mt-3 px-5">
                                <p className="text-[#737E91]">Standard Shipping</p>
                                <p className="text-[#283D63]">45 SR</p>
                            </div>

                            <hr className="border border-[#FBDED2] my-5" />

                            <div className="flex items-center justify-between mt-3 px-5">
                                <p className="text-[#737E91]">Sub-Total</p>
                                <p className="text-[#283D63]">945 SR</p>
                            </div>
                            <div className="flex items-center justify-between mt-3 px-5">
                                <p className="text-[#737E91]">Discount</p>
                                <p className="text-[#283D63]">0 SR</p>
                            </div>
                            <div className="flex items-center justify-between mt-3 px-5">
                                <p className="text-[#737E91]">Tax (14%)</p>
                                <p className="text-[#283D63]">43 SR</p>
                            </div>

                            <hr className="border border-[#FBDED2] my-5" />

                            <div className="flex items-center justify-between mt-3 px-5">
                                <p className="text-[#283D63]">Order Total</p>
                                <p className="text-[#283D63] font-semibold text-xl">987 SR</p>
                            </div>
                        </div> */}
                        <div className="bg-white border-2 border-[#EAA182] rounded-3xl py-6 text-lg">
                            <h3 className="text-[#14294F] text-2xl text-center font-bold leading-relaxed mb-5">
                                Order Summary
                            </h3>
                            {ordersCart[0]?.carts.map((ca, idx) => {
                                return ca.cart == null ? (
                                    " "
                                ) : (
                                    <div className="flex items-center justify-between px-5">
                                        <p className="text-[#737E91]">
                                            x{ca.cart?.count}{" "}
                                            {language == "en"
                                                ? ca.cart?.Products[0].name_en
                                                : ca.cart?.Products[0].name_ar}
                                        </p>
                                        <p className="text-[#283D63]">{ca.cart?.unite_price} SR</p>
                                    </div>
                                );
                            })}

                            <hr className="border border-[#FBDED2] my-5" />

                            <p className="text-[#A5AFC0] text-base px-4">Shipping</p>
                            <div className="flex items-center justify-between mt-3 px-5">
                                <p className="text-[#737E91]">Standard Shipping</p>
                                <p className="text-[#283D63]">{ordersCart[0]?.shipping} SR</p>
                            </div>
                            <hr className="border border-[#FBDED2] my-5" />
                            <div className="flex items-center justify-between mt-3 px-5">
                                <p className="text-[#737E91]">Sub-Total</p>
                                <p className="text-[#283D63]">{ordersCart[0]?.sub_total} SR</p>
                            </div>
                            <div className="flex items-center justify-between mt-3 px-5">
                                <p className="text-[#737E91]">Discount</p>
                                <p className="text-[#283D63]">{ordersCart[0]?.discount} SR</p>
                            </div>
                            <div className="flex items-center justify-between mt-3 px-5">
                                <p className="text-[#737E91]">Tax</p>
                                <p className="text-[#283D63]">{ordersCart[0]?.tax} SR</p>
                            </div>
                            <hr className="border border-[#FBDED2] my-5" />
                            <div className="flex items-center justify-between mt-3 px-5">
                                <p className="text-[#283D63]">Order Total</p>
                                <p className="text-[#283D63] font-semibold text-xl">
                                    {ordersCart[0]?.total_cost} SR
                                </p>
                            </div>
                        </div>

                        {/* <div className="relative mb-5">
                            <div className="mt-8 flex items-center">
                                <button
                                    className="text-white rounded-xl px-10 py-3 font-semibold border-2 border-[#FE804A] absolute z-10"
                                    style={{
                                        background:
                                            "radial-gradient(50% 50% at 50% 50%, #FE6625 0%, #FFAB88 100%)",
                                    }}
                                >
                                    {couponStatus === "loading" ? "..." : "Verify"}
                                </button>
                                <Input
                                    placeholder="Add coupon code here"
                                    value={couponInput}
                                    onChange={(e) => setCouponInput(e.target.value)}
                                    className="h-[52px] border-0 bg-white coupon_input relative z-0 w-2/3 ml-28"
                                />
                            </div>
                            {coupon && couponStatus === "succeeded" && (
                                <div className="mt-3 flex items-center justify-between px-2">
                                    <p className="text-green-600 text-sm">
                                        Coupon "{coupon}" applied
                                    </p>
                                    <button
                                        onClick={handleClearCoupon}
                                        className="text-[#CC0F0F] text-sm hover:underline"
                                    >
                                        Remove
                                    </button>
                                </div>
                            )}
                            {couponStatus === "failed" && (
                                <p className="text-[#CC0F0F] text-sm mt-3 px-2">
                                    {couponError || "Invalid coupon code"}
                                </p>
                            )}
                        </div> */}
                    </div>

                    {current === 0 && (
                        // <button onClick={next}
                        //     className="bg-[#FE9B71] text-white rounded-full px-14 py-3 my-5 mx-auto font-semibold flex"
                        // >
                        //     Continue
                        // </button>
                        <button
                            type="button"
                            onClick={handleContinue}
                            disabled={updateStatus === "loading"}
                            className="bg-[#FE9B71] text-white rounded-full px-14 py-3 my-5 mx-auto font-semibold flex disabled:opacity-50"
                        >
                            {updateStatus === "loading" ? "Updating..." : "Continue"}
                        </button>
                    )}

                    {current === 1 && (
                        <button
                            onClick={handleSubmitOrder}
                            disabled={submitStatus === "loading"}
                            className="bg-[#FE9B71] text-white rounded-full px-14 py-3 my-5 mx-auto font-semibold flex"

                        >
                            {submitStatus === "loading" ? "Submitting..." : "Submit Order"}
                        </button>
                    )}

                </div>
            </div>

        </div>
    );
};

export default Checkout;